import { CartBox } from './cart_box';

export default CartBox;
